// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202601161433/js/" + chunkId + "." + {"44":"1757c799","225":"44525b14","481":"c84da04e","486":"e34261c8","770":"fe1bf5af"}[chunkId] + ".0.659249622969742.chunk.js";
};